import { render, staticRenderFns } from "./acceptFormatting.vue?vue&type=template&id=a9fb747e"
import script from "./acceptFormatting.vue?vue&type=script&lang=js"
export * from "./acceptFormatting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports